import React, { Component } from 'react';

import { connect } from 'react-redux';

import Cookies from "js-cookie";

import { Alert, Col, Container, Row, Form, Button , Modal } from 'react-bootstrap';

import { toggleCollapsedNav } from '../redux/action/Theme';

import requester from "../library/Requester"; 
import * as Actions from './actions/ActionCenter';
import * as util from '../library/utilitys';

import logoWhite from '../assets/img/EEC-Logo-White.svg';
import logoOrange from '../assets/img/Logo-th.png';
// import leftSideBg from '../assets/img/testbg2.jpg';
import leftSideBg from '../assets/img/Login1_0.png';
import SendEmailResetPassword from './SendEmailResetPassword';

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            csrfToken: localStorage.getItem("csrfToken") || null,
            authToken: localStorage.getItem("authToken") || null,
            userProfile: Cookies.get("userProfile") ? JSON.parse(Cookies.get("userProfile")) : null,
            sidebarPermit: Cookies.get("sidebarPermit") ? JSON.parse(Cookies.get("sidebarPermit")) : null,
            error: null,
            username: '',
            password: '',
            remember: false,
            isMobile: window.innerWidth < 768,
        };
    }

    handleResize = () => {
      this.setState({
        isMobile: window.innerWidth < 768,
      });
    };

    componentDidMount = () => {
        window.addEventListener('resize', this.handleResize);
    }
    
    componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
    }

    handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        this.setState({ [name]: type === 'checkbox' ? checked : value });
    };

    getCsrfToken = () => {
        requester.get("/public/csrf-token")
            .then((response) => {
                const csrfToken = response.data.csrfToken;
                localStorage.setItem("csrfToken", csrfToken);
                this.setState({ csrfToken }, () => {
                    this.getLoginToken(); 
                }, () => { 
                    util.debug(this.state, 'GET-CSRF-TOKEN-SUCCESS', this.state.csrfToken); 
                });
            })
            .catch((error) => {
                console.error("Error fetching CSRF Token", error);
                this.setState({ error: "Failed to fetch CSRF token" }, () => {
                    util.debug(this.state, 'GET-CSRF-TOKEN-SUCCESS-FAIL'); 
                });
            });
    };

    getLoginToken = () => {

        const { username, password} = this.state;
        
         requester.post("/login/external", {username: username, password: password}, {
            headers: { "X-CSRF-Token": this.state.csrfToken }
        })
        .then((response) => {
            const { token, user , permission } = response.data;

            localStorage.setItem("authToken", token);

            /* for dev */
            // console.log("SETTING COOKIE IN DEV");

            //     Cookies.set("userProfile", JSON.stringify(user), {
            //     expires: 7,
            //     secure: false,
            //     sameSite: "Lax"
            //     });
            /* end for dev */
                
            const cookieOptions = {
                expires: process.env.REACT_APP_COOKIE_AGE 
                    ? Number(process.env.REACT_APP_COOKIE_AGE) 
                    : 7, // ถ้าไม่ตั้งใน .env ให้ default = 7 วัน
                secure: process.env.REACT_APP_ENV_MODE === "production", // prod = true, dev = false
                sameSite: "Lax"
            };

            Cookies.set("userProfile", JSON.stringify(user), cookieOptions);
            Cookies.set("sidebarPermit", JSON.stringify(permission), cookieOptions);

            this.setState({ authToken: token, userProfile: user, sidebarPermit: permission }, () => {
                util.debug(this.state, 'GET-TOKEN-AND-USER-PROCESS-SUCCESS')
            });
            
            window.location.href = "/apps/dashboard";
            
            // Actions.navigate(this.props.navigate, "/apps/dashboard", {});
            
        })
        .catch((error) => {
             let errorMessage = "ชื่อผู้ใช้หรือรหัสผ่านผ่านไม่ถูกต้อง";
            console.log("error",error?.response?.data?.error);
            
            if (error?.response?.data?.error === "Too many login attempts.") {
                errorMessage = "มีการเข้าสู่ระบบหลายครั้งเกินไป กรุณาลองใหม่ภายหลัง";
            }
            console.log(errorMessage);
            
            this.setState({ error: errorMessage, showModal: true }, () => {
                util.debug(this.state, 'GET-TOKEN-AND-USER-PROCESS-FAIL');
            });
        });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        this.getCsrfToken();
    };

    render() {
        return (
            <>
            <Container fluid className="vh-100 d-flex">
                <Row className="flex-fill">

                    {/* Left Side */}
                    <Col md={4} className="d-flex flex-column justify-content-between align-items-center text-white"
                        style={{
                            backgroundColor: '#eae9e5',
                            backgroundImage: `url(${leftSideBg})`,
                            padding: '5%',
                            backgroundSize:  window.innerWidth < 768 ? '100%' : '100% auto',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center',
                            color: 'white',
                            textAlign: 'center',
                            height: window.innerWidth < 768 ? '35%' : ''
                        }}
                        >
                        <div className="text-center" style={{ marginTop: '-30px' }}>
                            {!(window.innerWidth < 768) && <img
                                src={logoOrange}
                                alt="EEC Logo"
                                style={{ 
                                    width: '65%',
                                    filter: 'drop-shadow(-10 6px 12px rgba(0,0,0,0.35))',
                                }}
                            />}
                        </div>
                        {/* <Row className="d-flex justify-content-center align-items-start" style={{ width: '100%' }}>
                            <div className="text-center">
                                <p className="mt-5" style={{ color: '#FFFFFF99', fontSize: 14 }}>&copy; 2019 Eastern Economic Corridor (EEC) Office</p>
                            </div>
                        </Row> */}
                    </Col>
                    <Col md={1}/>
                    
                    {/* Right Side */}
                    <Col md={7} className="d-flex flex-column justify-content-center " style={{ padding: '10%' }}>
                        <div className="mb-4">
                            <h3 className="text-orange fw-bold">EEC มีงานทำ</h3>
                            <h5 className="fw-normal">เข้าสู่ระบบก่อนใช้งาน</h5>
                        </div>
                       <Form onSubmit={this.handleSubmit}>
                            <Form.Group className="mb-3">
                                <Form.Label>ชื่อผู้ใช้</Form.Label>
                                <Row>
                                <Col xs={12} md={9} lg={9}>
                                    <Form.Control
                                    type="text"
                                    placeholder="username"
                                    name="username"
                                    value={this.state.username}
                                    onChange={this.handleInputChange}
                                    className="w-100"
                                    />
                                </Col>
                                </Row>
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>รหัสผ่าน</Form.Label>
                                <Row>
                                    <Col xs={12} md={9} lg={9}>
                                    <div style={{ position: "relative" }}>
                                        <Form.Control
                                        type={this.state.showPassword ? "text" : "password"}
                                        placeholder="******"
                                        name="password"
                                        value={this.state.password}
                                        onChange={this.handleInputChange}
                                        style={{
                                            paddingRight: "2.5rem", // เว้นที่ไว้ให้ไอคอน
                                            height: "45px",
                                        }}
                                        />
                                        <i
                                        className={this.state.showPassword ? "fa fa-eye-slash" : "fa fa-eye"}
                                        onClick={() =>
                                            this.setState({ showPassword: !this.state.showPassword })
                                        }
                                        style={{
                                            position: "absolute",
                                            right: "12px",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            cursor: "pointer",
                                            color: "#6c757d",
                                            fontSize: "1.1rem",
                                        }}
                                        />
                                    </div>
                                    </Col>
                                </Row>
                            </Form.Group>

                           {this.state.error && (
                            <Row className="mt-2">
                                <Col xs={12} md={9} lg={9}>
                                <Alert variant="danger" style={{ fontSize: '14px' }}>
                                    {this.state.error}
                                </Alert>
                                </Col>
                            </Row>
                            )}

                            <Row className="mt-4">
                                <Col xs={12} md={9} lg={9}>
                                    <Button
                                        type="submit"
                                        className="w-100 p-2"
                                        style={{
                                            backgroundColor: '#f99e39',
                                            border: 'none',
                                        }}
                                        >
                                        เข้าสู่ระบบ
                                    </Button>
                                </Col>
                            </Row>

                            <Row className='my-2'>
                                <Col xs={12} md={9} lg={9} className="text-end">
                                    <span
                                        role="button"
                                        tabIndex={0}
                                        className="text-decoration-underline cursor-pointer"
                                        onClick={() => this.resetModal?.open('E')}
                                        style={{ color: '#f99e39' }}
                                    >
                                        ลืมรหัสผ่าน?
                                    </span>
                                </Col>
                            </Row>

                            {/* <Button type="submit" className="w-100 p-2" style={{ backgroundColor: '#f99e39', border: 'none' }}
                            >
                                เข้าสู่ระบบ
                            </Button> */}
                            <p className="my-5">
                                <div className="">
                                    <a href="https://www.facebook.com/eecwecan" target="_blank" rel="noopener noreferrer" ><i className="fab fa-facebook fa-2x mx-2 text-blues"></i></a>
                                    <a href="https://www.youtube.com/@eecwecan" target="_blank" rel="noopener noreferrer" ><i className="fab fa-youtube fa-2x mx-2 text-red"></i></a>
                                </div>
                            </p>

                            <div className="mt-3 text-start">
                                ไม่มีบัญชีผู้ใช้? <a href="/register" target="_blank" className="text-orange" style={{ color: '#f99e39' }}>ลงทะเบียน</a>
                            </div>
                        </Form>
                    </Col>

                </Row>
            </Container >
                {/* <Modal
                    show={this.state.showModal}
                    onHide={() => this.setState({ showModal: false })}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>ไม่สามารถเข้าสู่ระบบได้</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>{this.state.error}</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.setState({ showModal: false })}>
                            ปิดหน้าต่าง
                        </Button>
                    </Modal.Footer>
                </Modal> */}
            <SendEmailResetPassword ref={ref => (this.resetModal = ref)}/>
            </>
        );
    }
}

const mapStateToProps = ({ theme }) => {
    const { navCollapsed } = theme;
    return { navCollapsed };
}

export default connect(mapStateToProps, { toggleCollapsedNav })(Login);